export const loadScript = (url: string, onLoad: any) => {
  const script = document.createElement('script')
  script.src = url
  script.async = true
  script.onload = onLoad

  document.body.appendChild(script)
  return () => {
    document.body.removeChild(script)
  }
}
